import React from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { AggregateCostAndChargesTypes } from 'store/modules/Charts/types';
import { formatCurrency } from 'utils';
import { TooltipAggregateCostCharges } from '../Tooltips';
import { adviserCharges, emptyColor } from '../Utils';
import { useTheme } from '@material-ui/styles';

interface Props {
  data: AggregateCostAndChargesTypes[];
  isAnimationActive?: boolean;
  height?: number;
  bigLabels?: boolean;
}

const Tick = ({ payload: { value }, bigLabels, ...rest }: any) => (
  <text
    {...rest}
    className="bar-chart-tick"
    dy={12}
    fontSize={bigLabels ? '16px' : 'inherit'}
  >
    {value}
  </text>
);

const AggregateCostAndCharges = ({
  data,
  isAnimationActive = true,
  height = 310,
  bigLabels = false
}: Props) => {
  const theme = useTheme() as any;
  const isData = data && data.length > 0;
  const dataToRender = isData ? data : [];

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={dataToRender}
        margin={{ top: 20, right: 30, left: 35, bottom: 10 }}
      >
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis dataKey="year" tick={<Tick bigLabels={bigLabels} />} />
        <YAxis
          tickFormatter={(val: any) => formatCurrency(val)}
          tick={{ fontSize: bigLabels ? '12px' : 'inherit' }}
        />

        <Tooltip content={TooltipAggregateCostCharges} />

        {Object.keys(adviserCharges).map((key: string, index: number) => {
          return (
            <Bar
              key={key}
              dataKey={key}
              stackId="a"
              fill={
                isData
                  ? theme.palette.baseColors.charts['adviser-charges'][index]
                  : emptyColor
              }
              isAnimationActive={isAnimationActive}
            >
              {data.map((entry: any, index: number) => {
                let radius = 0;
                let maxKey = '';

                Object.keys(adviserCharges).forEach((barKey: string) => {
                  if (Number(entry[barKey]) !== 0) {
                    maxKey = barKey;
                  }
                });

                if (maxKey === key) {
                  radius = 25;
                }

                return (
                  // @ts-ignore
                  <Cell key={`cell-${index}`} radius={[radius, radius, 0, 0]} />
                );
              })}
            </Bar>
          );
        })}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AggregateCostAndCharges;
